import { MovieStreamAudioMetaFragment } from '@funtech-int/kp-graphql-sdk/yango-movies-www';

import { transformAudio } from '../../movie-player/transformers/transform-audio';

import { useEpisodeOtt } from './use-episode-ott';

export function useAudio(contentId: string) {
    const episode = useEpisodeOtt(contentId);

    if (episode) {
        return transformAudio(
            (episode.onlineStreams?.streams?.[0]?.streamMeta
                ?.audioMetas as MovieStreamAudioMetaFragment[]) || []
        );
    }
}
